angular.module('myApp.services')
    .factory("messagesHolder", function() {
        var _messages = {};
        return {
            setMessages : function (messages) {
                if (typeof messages == 'object') {
                    _messages = messages;
                }
            },
            getMessages : function (key) {
                if (!key) {
                    return _messages;
                } else if (key in _messages) {
                    return _messages[key];
                }
                return null;
            }
        }
    });